import { render, staticRenderFns } from "./RemovePrebuiltForms.vue?vue&type=template&id=4ffd3661&"
import script from "./RemovePrebuiltForms.vue?vue&type=script&lang=ts&"
export * from "./RemovePrebuiltForms.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports